module.exports = __webpack_public_path__ + "img/sample_map3.4620ae23.png";